'use client';

import React from "react";

function SecondaryTag({ text, className, ...props }) {
  return (
    <div
      className={`flex justify-center items-center gap-2 py-2 px-4 rounded-full border border-color-97 text-color-2 text-center font-medium leading-[normal] ${className}`}
      {...props}
    >
      {text}
    </div>
  );
}
export default SecondaryTag;
